// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version
// MODFIED DATE : 05-09-2025

const VerificationDetailsActionTypes = {
	// ADD BUSINESS VERIFICATION RESPONSE
	ADD_BUSINESS_VERIFICATION_START: 'add_business_verification_start',
	ADD_BUSINESS_VERIFICATION_SUCCESS: 'add_business_verification_success',
	ADD_BUSINESS_VERIFICATION_FAILURE: 'add_business_verification_failure',
	ADD_BUSINESS_VERIFICATION_RESPONSE_RESET: 'add_business_verification_response_reset',
	ADD_BUSINESS_VERIFICATION_RESPONSE_CHANGED: 'add_business_verification_response_changed',

	// UPDATE BUSINESS VERIFIACTION RESPONSE
	UPDATE_BUSINESS_VERIFICATION_START: 'update_business_verification_start',
	UPDATE_BUSINESS_VERIFICATION_SUCCESS: 'update_business_verification_success',
	UPDATE_BUSINESS_VERIFICATION_FAILURE: 'update_business_verification_failure',
	UPDATE_BUSINESS_VERIFICATION_RESPONSE_RESET: 'update_business_verification_response_reset',
	UPDATE_BUSINESS_VERIFICATION_RESPONSE_CHANGED: 'update_business_verification_response_changed',

	// FETCH BUSINESS VERIFICATION RESPONSE
	FETCH_BUSINESS_VERIFICATION_START: 'fetch_business_verification_start',
	FETCH_BUSINESS_VERIFICATION_SUCCESS: 'fetch_business_verification_success',
	FETCH_BUSINESS_VERIFICATION_FAILURE: 'fetch_business_verification_failure',
	FETCH_BUSINESS_VERIFICATION_RESPONSE_RESET: 'fetch_business_verification_response_reset',
	FETCH_BUSINESS_VERIFICATION_RESPONSE_CHANGED: 'fetch_business_verification_response_changed',

	// DELETE BUSINESS VERIFICATION RESPONSE
	DELETE_BUSINESS_VERIFICATION_START: 'delete_business_verification_start',
	DELETE_BUSINESS_VERIFICATION_SUCCESS: 'delete_business_verification_success',
	DELETE_BUSINESS_VERIFICATION_FAILURE: 'delete_business_verification_failure',
	DELETE_BUSINESS_VERIFICATION_RESPONSE_RESET: 'delete_business_verification_response_reset',
	DELETE_BUSINESS_VERIFICATION_RESPONSE_CHANGED: 'delete_business_verification_response_changed',
};
export default VerificationDetailsActionTypes;
